import type { ThemeOptions } from '@mui/material/styles';

export const zIndex: ThemeOptions['zIndex'] = {
  skipLink: 9999,
};
